import Axios from "axios";

const state = {
  facetClassification: null
};

const getters = {
  getFacetClassification: state => {
    return state.facetClassification;
  }
};

const mutations = {
  UPDATE_FACETED_CLASSIFICATION: (state, payload) => {
    state.facetClassification = payload;
  }
};

const actions = {
  /**
   * This action load the facet content for the entire database.
   * It also reset Vuex observation store observation and mapitems arrays to []
   */
  initFacets: store => {
    let headers = {
      "Content-Type": "application/json"
    };
    return new Promise(resolve => {
      Axios.post("trajectories/observation/initFacets", {
        headers
      }).then(response => {
        store.commit("UPDATE_FACETED_CLASSIFICATION", response.data),
        store.commit("UPDATE_MAP_ITEMS", []);
        store.commit("UPDATE_OBSERVATIONS", []);
        resolve();
      });
    });
  }
};

export let facets = {
  state,
  getters,
  mutations,
  actions
};
